import { useAuth } from "@/features/auth/auth-provider";

export function useOperatorConsoleAccess() {
  const { isPlatformAdmin, roles, status } = useAuth();

  const isTenantAdmin = roles.includes("TenantAdmin");
  const hasAccess = isPlatformAdmin || isTenantAdmin;

  return {
    hasAccess,
    isLoading: status === "loading",
    isPlatformAdmin,
    isTenantAdmin,
    roles,
  };
}
